// extracted by mini-css-extract-plugin
module.exports = {"root":"rdg_73142b5c","verticalImage":"rdg_4ffd5de8 rdg_73142b5c","horizontalImage":"rdg_935c2a1b rdg_73142b5c"};